// Rating read-back via the gateway's GET /rating/:playerId proxy. The client
// never talks to matchmaking directly — one public origin.

export interface PlayerRating {
  readonly playerId: string;
  readonly rating: number;
  readonly rd: number;
  readonly volatility: number;
  readonly league: string;
  readonly wins: number;
  readonly losses: number;
  readonly games: number;
}

type FetchLike = (input: string, init?: RequestInit) => Promise<Response>;

/** Fetch a player's rating. Returns null when the gateway is unreachable. */
export async function fetchRating(
  gatewayHttpUrl: string,
  playerId: string,
  fetchImpl: FetchLike = fetch,
): Promise<PlayerRating | null> {
  try {
    const res = await fetchImpl(`${gatewayHttpUrl}/rating/${encodeURIComponent(playerId)}`, {
      headers: { accept: 'application/json' },
    });
    if (!res.ok) return null;
    return (await res.json()) as PlayerRating;
  } catch {
    return null;
  }
}
